<app-mmx-icon *ngIf="isLoaderVisible$ | async" id="app-loader"></app-mmx-icon>

<router-outlet></router-outlet>
